/**
 * Hero with Trailer JavaScript
 * Handles video autoplay and mute/unmute functionality
 */

(function() {
  'use strict';

  class HeroWithTrailer {
    constructor() {
      this.init();
    }

    init() {
      // Wait for DOM to be ready
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.setupVideos());
      } else {
        this.setupVideos();
      }
    }

    setupVideos() {
      const heroSections = document.querySelectorAll('.hero-with-trailer-section');
      
      if (heroSections.length === 0) return;

      heroSections.forEach((section) => {
        const video = section.querySelector('.trailer-video');
        const muteButton = section.querySelector('.mute-toggle-button');
        
        if (!video) return;

        // Ensure video is muted and autoplays
        video.muted = true;
        video.setAttribute('muted', '');
        
        // Try to autoplay
        const playPromise = video.play();
        
        if (playPromise !== undefined) {
          playPromise
            .then(() => {
              // Autoplay started successfully
              console.log('Video autoplay started');
            })
            .catch((error) => {
              // Autoplay was prevented (browser policy)
              console.log('Autoplay prevented, user interaction required:', error);
              // Show a play button overlay if needed
              // For now, we'll just log it
            });
        }

        // Setup mute/unmute button if it exists
        if (muteButton) {
          muteButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.toggleMute(video, muteButton);
          });
        }

        // Handle video errors
        video.addEventListener('error', (e) => {
          console.error('Video error:', e);
        });

        // Handle video loading
        video.addEventListener('loadeddata', () => {
          // Video data loaded, ensure it's playing
          if (video.paused) {
            video.play().catch((error) => {
              console.log('Play failed after load:', error);
            });
          }
        });

        // Ensure video loops
        video.loop = true;
      });
    }

    toggleMute(video, button) {
      if (video.muted) {
        // Unmute
        video.muted = false;
        video.removeAttribute('muted');
        button.classList.add('unmuted');
        button.setAttribute('aria-label', 'Mute video');
        button.setAttribute('title', 'Mute video');
      } else {
        // Mute
        video.muted = true;
        video.setAttribute('muted', '');
        button.classList.remove('unmuted');
        button.setAttribute('aria-label', 'Unmute video');
        button.setAttribute('title', 'Unmute video');
      }
    }
  }

  // Initialize on page load
  new HeroWithTrailer();
})();

